import React, { useEffect } from 'react';
import '../PlatformCostObs/dashboard.scss';
import PageHeader from 'components/Header/Page';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import ReportsIcon from '../../assets/reports_icon.png';
import PageWrapper from 'components/Common/PageWraper';

const DMOMetrics = () => {
    const [controller] = usePepwiseAuthController();
    const { role } = controller;

    useEffect(() => {
        const activeId = document.getElementById('root');
        console.log(window.location.pathname);
        if (window.location.pathname.includes('/D&AIXOps') && role !== "Program Executive") {
            if (activeId) {
                document.head.classList.add('theme-bg-blue');
                document.body.classList.add('theme-bg-blue');
            }
        }
    }, []);
    return (
        // <div className="base-tab">
        <PageWrapper>
            <PageHeader title="DMO Metrics" icon={ReportsIcon}> </PageHeader>
            <AnalyticsVisualization
                params={{
                    dashboardUrl: 'https://app.powerbi.com/reportEmbed?reportId=99d5aa87-dea2-442f-b86d-89542bcc5739',
                    className: 'powerBiIframeContainer',
                    otherParams: {
                        name: 'PowerBI'
                    },
                    seamless: true
                }}
            />
        </PageWrapper>
        // </div>
    );
};
export default DMOMetrics;